import { Component, OnInit } from '@angular/core';
import { UserApiService } from '../../services/user-api.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { LoggerService } from 'src/app/services/logger.service';

@Component({
  selector: 'app-balance-preview',
  templateUrl: './balance-preview.component.html',
  styleUrls: ['./balance-preview.component.css']
})
export class BalancePreviewComponent implements OnInit {
  public constructor(
    private logger: LoggerService,
    private apiService: UserApiService
  ) {
  }

  public sumBalance: number = 0;
  public sumCredit: number = 0;

  public loading: boolean = true;

  public ngOnInit(): void {

    try {
      this.loading = false;
      let urlAccount = `Accountent?orderBy=&direction=&page=0&size=1000&paginate=false&search=`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(urlAccount))) {
        return;
      }

      this.apiService.getWitoutPage(new ApiRequestModel(urlAccount))
        .subscribe(
          result => {
            this.logger.addResponseLog(urlAccount, result, `Get All`);
            if (!result.data) {
              return;
            }
            for (let index = 0; index < result.data.length; index++) {
              const element = result[index];
              if (element.prepaid) {
                this.sumBalance += element.clientCredit;
              }
              else {
                this.sumCredit += element.clientCredit;
              }
            }
            this.loading = false;
          },
          error => {
            this.logger.addError(error,true);
          },
          () => {
          }
        );
    } catch (error) {
      this.logger.addException(error,true);
    }
  }
}
